// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import EditorController from "./editor_controller"
import CorporateSignupController from "./corporate_signup_controller"
application.register("editor", EditorController)
application.register("corporate-signup", CorporateSignupController)
